<!-- @format -->

<template>
	<div class="custom-modal">
    	<HolaconLottie v-if="loading == 'created'" class="w-100" key="create-loading" />

		<div class="modal-body" v-else key="content-loading">
			<el-row>
				<el-col :span="24" class="d-flex align-center justify-content-center mb-3">
					<lottie-player autoplay loop mode="normal" src="/static/lottie/holacon-voucher-send-lottie.json" style="width: 150px"> </lottie-player>
				</el-col>
				<transition name="el-fade-in" mode="out-in">
					<el-col :span="24" v-if="sendVoucherLoading == false">
						<el-row :gutter="16">
							<el-col :span="12">
								<div class="registration-question">
									<div class="sub-title">{{$t('components.participants.sendVoucher.draftSelection')}}</div>
									<el-select v-model="form.automatedMessageId" :clearable="true" @clear="form.automatedMessageId = null">
										<el-option v-for="voucher in voucherList.filter((x) => x.category == 0)" :key="voucher.id" :value="voucher.id" :label="voucher.title"></el-option>
									</el-select>
								</div>
							</el-col>
							<el-col :span="12">
								<div class="registration-question">
									<div class="sub-title">{{$t('components.participants.sendVoucher.voucherType')}}</div>
									<el-select v-model="form.type" :clearable="true" @clear="form.type = null">
										<el-option label="Voucher - Email" :value="0"></el-option>
										<el-option label="Voucher - SMS" :value="24"></el-option>
									</el-select>
								</div>
							</el-col>
						</el-row>
					</el-col>
					<el-col :span="24" class="text-center" v-if="sendVoucherLoading == 'sending'" key="title">
						<p>{{$t('components.participants.sendVoucher.sendingStart')}}</p>
						<p>{{$t('components.participants.sendVoucher.sendingStartInfo')}}</p>
					</el-col>
					<el-col :span="24" v-if="sendVoucherLoading == 'completed'" class="text-center">
						<p>{{$t('components.participants.sendVoucher.sendingEnd')}}</p>
					</el-col>
				</transition>
			</el-row>
		</div>
		<div class="modal-footer" slot="footer">
			<div class="left-buttons">
				<el-button @click="$emit('closeMe')">{{ $t('contentManagement.speakers.speakerAddUpdate.close') }}</el-button>
				<!-- <template>
            <el-popconfirm :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
              <el-button slot="reference" type="danger" icon="fas fa-trash"> {{ $t('contentManagement.speakers.speakerAddUpdate.delete') }}</el-button>
            </el-popconfirm>
          </template> -->
			</div>
			<div class="right-buttons" v-if="sendVoucherLoading == false">
				<el-button type="primary" @click="startVoucherSend" :loading="loading == true">{{$t('components.participants.sendVoucher.startSending')}}</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['payload'],
		name: 'SendVoucher',
		data() {
			return {
				sendVoucherLoading: false,
				loading: false,
				form: JSON.parse(JSON.stringify(this.payload)),
				timeout: null,
			}
		},
		computed: {
			voucherList() {
				return this.$store.state.automatedmessages.items
			},
		},
		async created() {
			 this.loading = "created";
			if (this.timeout != null) clearTimeout(this.timeout);
			this.timeout = setTimeout(async () => {
				await this.$store.dispatch('getAutomatedMessagesList')
				if (this.$store.state.participants.automatedMessageId != null) {
					var fIndex = this.voucherList.findIndex((x) => x.id == this.$store.state.participants.automatedMessageId)
					if (fIndex != -1) {
						this.form.automatedMessageId = this.$store.state.participants.automatedMessageId
					} else {
						this.$store.state.participants.automatedMessageId = null
					}
				}
				if (this.$store.state.participants.automatedMessageType != null) {
					this.form.type = this.$store.state.participants.automatedMessageType
				}
				this.loading = false;
			}, 500);
		},
		methods: {
			async startVoucherSend() {
				this.loading = true
				this.sendVoucherLoading = 'sending'
				if (this.timeout != null) clearTimeout(this.timeout)
				this.timeout = setTimeout(async () => {
					var res = await this.$store.dispatch('sendVoucherParticipant', this.form)
					if (!res.data.alert.hasError) {
						this.sendVoucherLoading = 'completed'
					} else {
						this.sendVoucherLoading = false
					}
					this.loading = false
				}, 500)
			},
		},
	}
</script>

<style lang="less" scoped>
	.export-display {
		background-color: #03658c;
		padding: 1rem;
		border-radius: 1rem;
		display: flex;
		gap: 10px;
		flex-direction: column;
		.first {
			display: flex;
			gap: 10px;
			.total {
				background-color: white;
				padding: 10px;
				border-radius: 1rem;
				font-weight: bold;
				text-align: center;
				flex-shrink: 0;
			}
			.file-name {
				width: 100%;
				background-color: white;
				padding: 10px;
				border-radius: 1rem;
				font-weight: bold;
				text-align: center;
				position: relative;

				display: flex;
				align-items: center;
				.file {
					width: 280px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				i {
					position: absolute;
					right: 1rem;
					top: calc(~'50% - 9px');
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/participants/SendVoucher.vue